<template>
    <div class="motionSection reveal" ref="photocontents">
        <div class="sectionTitle black fsTitle">
            <splitter :content="localize(sectionData.title)"></splitter>
        </div>
        <div class="stickySec">
            <div class="photos" v-if="styles.length>0">
<!--                 <div class="items">
                    <figure class="photoImg" v-for="(item, index) in sectionData.items" :key="'photoimg_'+index">
                        <div class="ptWrapper">                            
                            <img class="ptImg" :style="styles[index].imgCss" :src="item.img" />                            
                        </div>
                    </figure>
                </div>
 -->            </div>
        </div>
    </div>
</template>

<!-- :style="getImgStyle(index)" -->
<!-- <span class="ptTitle">{{localize(item.title)}}</span> -->
<!-- {{sectionScrollProg.index}} -->
<!-- {{sectionScrollProg.prog}} -->




<style scoped>
  .motionSection
  {    
    height: 300vh;
    color: #fff;
   /*  background-color: #eee; */
  }
  .stickySec
  {
    position: sticky;
    top: 0px;
    display: flex;
    overflow: visible;
    height: 100vh;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    font-size: 20px;
  }
    .photos 
    {
        width:90vw;
        max-width: 1400px;
        height: 80vh;
        position: relative;
        border: solid 2px red;
    }
    .items
    {
        width: 100%;
        height: 100%;
    }
    .items figure
    {
        text-align: center;
        width: 100%;       
        position: absolute;
        top:50%; 
        transform: translateY(-50%);
    }
    .ptWrapper
    {
        position: relative;
    }
    .ptWrapper .ptTitle
    {
        font-size: 30px;
        color: #202020;
        position: absolute;
        top: 0px;
        left: 0px;
        width: 100%;
        top:40px;
    }    
    .ptWrapper .ptImg
    {
        position: absolute;
        top: 0px;
        left: 0px;
        width: 100%;
        height: auto;        
        margin: auto;
        opacity: 0;
    }
    @media (min-width: 850px) { 
    }

    @media (max-width: 850px) { 

    }    

    /* Portrait iPad mini 1, iPad 1 and iPad 2*/
    @media only screen 
    and (min-device-width: 768px) 
    and (max-device-width: 1024px) 
    and (-webkit-min-device-pixel-ratio: 1) 
    and (orientation: portrait)
    {
    }    

</style>

<script>
import { mapActions, mapState } from "vuex";
import sidepager from "@/views/com/sidepager.vue";
import splitter from "@/views/com/splitter.vue";
import { splitLines,isMobileScreen }         from "@/utils";

export default 
{
    components: { sidepager,splitter },
    data()
    {
        return{
            arrTextH:[],
            secIndex:1,
            name:'benefits',
            selectedIndex:0,
            elementTitle:'',
            elementDesc:'',            
            sizerTitle:'',
            sizerContent:'',
            maxTextHeight:0,
            intChanger:Object,
            isAutoChanging:false,
            styles:[]
        }
    },
    props:{
        sectionDataIndex:Number,
        sectionScrollProg:Object
    },
    mounted()
    {
        let vm = this;
        setTimeout(() => {
            //vm.collectHeights();
            vm.updateStyles();//create the array
        }, 500);
        //setTimeout(() => {
            //this.setTextRectSize();    
        //}, 500);        
        //this.initImgScroller();        
        //this.setText();
    },
    destroyed() {
        
    },
    computed: {
        ...mapState(["xSelectedPlatform","siteData","siteDataReady","siteVisibleSection"]),
        sectionData()
        {
            return this.siteData.SECTIONS[this.sectionDataIndex];
        }
    },
    watch: {
        //sectionScrollProg
        '$store.state.sectionScrollProg': function() {
            //alert("updatung");
            //alert(this.sectionDataIndex);
            if(this.sectionScrollProg.index==this.sectionDataIndex)
            {
                this.updateStyles();
            }
        },
      '$store.state.siteVisibleSection': function() {
        var vm=this;        
        let _siteVisibleSection = this.$store.state.siteVisibleSection;        
        if(_siteVisibleSection==this.sectionDataIndex+1){
            //alert("start auto timer");
            //start the timer
            if(isMobileScreen()==false){
                //vm.startAutoChange();
            }
        }else
        {
            vm.stopAutoChange();
        }
      }
    },

    methods:
    {
        collectHeights()
        {
            let vm =this;
            vm.style = [];
            vm.arrTextH = [];
            let items = vm.$el.querySelectorAll(".bnItemDesc");
            for (var i = 0; i < items.length; i++) 
            {
                let br = items[i].getBoundingClientRect();
                vm.arrTextH.push(br.height);

                let itemStyle = {
                    textH:0,
                    alpha:0.5
                };
                vm.styles.push(itemStyle);
            }
            vm.updateStyles();
        },
        updateStyles()
        {
            //UPDATING ALL THE STYLES OF THE COMPONENT ACCORDING TO THE SCROLL PROGRESS
            var vm=this;
            let secProg = this.sectionScrollProg.prog; //precentage of the section
            vm.styles = [];
            let count = this.sectionData.items.length;
            for(let i=0;i<count;i++)
            {
                //change
                //opacity
                //visiblilty
                //mask size

                let partSize = 1/count;
                let itemStart = partSize*i;
                let itemEnd = itemStart+partSize;
                let delta = itemEnd - secProg;
                let partProg = 1 - (Math.abs(delta)/partSize);
                //let realPartProg = 1 - (delta/partSize);
                let pathSize = 20*(1-partProg); //20-0
                let newAlpha = partProg;//0-1

                let imgCss = "clip-path: inset("+pathSize+"% round 80px 80px 80px 80px);";
                imgCss = imgCss + "opacity:"+newAlpha;

                //Position of images
                //let positionProgress = realPartProg;
                //if(positionProgress>2){positionProgress=0;}
                //let newImgTrans = 50-((positionProgress*100)/2)-50;
                
                //imgSize:partProg < 0 ? 0 : partProg,

                let itemStyle = {
                    imgCss:imgCss
                };
                vm.styles.push(itemStyle);//array is initlizing
            }
        },
        getImgStyle(index)
        {
            let imgCss = '';
            if(this.sectionScrollProg.index==this.sectionDataIndex)
            {
                let secProg = this.sectionScrollProg.prog; //precentage of the section
                let pathSize = 20*(1-secProg); //20-0
                let imgOpacity = secProg;//0-1
                imgCss = "clip-path: inset("+pathSize+"% round 80px 80px 80px 80px);";
                imgCss = imgCss + "opacity:"+imgOpacity;
            }
            
            return imgCss;

            if(this.styles.length>0){
                //return "transform: translate3d("+this.styles[index].imgPos+"%,"+this.styles[index].imgPos+"%,0) scale("+this.styles[index].imgSize+")";
                //return "transform: translate3d(0%,0,0) scale("+this.styles[index].imgSize+")";
            }
            return '';
            //transform: translate3d(0,0,0) scale(0.2);
        },
        getTitleStyle(index)
        {
            if(this.styles.length>0){
                let cssData = this.styles[index];
                return 'opacity:'+cssData.alpha+";font-size:"+cssData.fontSize+"px";
            }
            return '';
        },
        getDescStyle(index)
        {
            if(this.styles.length>0){
                return 'height:'+this.styles[index].textH+'px';
            }
            return '';

            if(this.arrTextH.length>0)
            {

                let rectH = this.arrTextH[index];
                let secProg = this.sectionScrollProg.prog; //precentage of the section
                let partSize = 1/this.arrTextH.length; 
                let itemStart = partSize*index;
                let itemEnd = itemStart+partSize;
                let newH = 0;//
                let delta = Math.abs(itemEnd - secProg);
                let partProg = 1 - (delta/partSize);
                //console.log("index="+index+" delta="+delta);
                newH = rectH*partProg;// * this.sectionScrollProg.prog;
                return 'height:'+newH+'px';
            }
            //let items = this.$el;//.circontents;//.querySelectorAll(".bnItem");
            //alert(items);
            //let bnItemDesc = contentElement.querySelectorAll(".bnItemDesc")[0];
            //let bnItemDescEl = bnItem.querySelectorAll(".bnItemDesc")[0];
            //let rect = bnItemDescEl.getBoundingClientRect();
            //let newH = rect.height * this.sectionScrollProg.prog;
            return '';//'height:'+newH+'px';
        },
        stopAutoChange()
        {
            this.isAutoChanging=false;
        },
        startAutoChange()
        {
            var vm=this;
            vm.isAutoChanging = true;
            vm.setAutoTimerNext();
        },
        setAutoTimerNext()
        {            
            var vm =this;
            //alert("vm.isAutoChanging="+vm.isAutoChanging);
            if(vm.isAutoChanging)// && vm.siteVisibleSection==2)
            {
                //alert("setAutoTimerNext");
                setTimeout(() => 
                {
                    vm.moveToNextImage();   //move to the next image
                    vm.setAutoTimerNext(); //set the inerval again
                }, 6500);
            }
        },
        moveToNextImage()
        {
            if(!this.isAutoChanging){
                return false;
            }
            var vm=this;
            let newIndex = vm.selectedIndex+1;
            if(newIndex>vm.sectionData.items.length-1){
                newIndex=0;                    
            }
            vm.setItem(newIndex,true);                
        },
        checkScrollPosition() {
            //alert("benefits scroll");
            var vm=this;
            let scroller = vm.$refs.bnImgScroll1;
            let scrX = scroller.offsetLeft;
            let scrolledX = scroller.scrollLeft;
            
            var reveals = scroller.querySelectorAll(".bnImgItem");
            for (var i = 0; i < reveals.length; i++) 
            {
                //find the element to highligt 
                //console.log("__scrolledX="+scrolledX);
                //console.log("(scrolledX+scrX) ="+scrolledX+"+"+scrX+" === "+reveals[i].offsetLeft);

                //if((scrolledX+scrX)==reveals[i].offsetLeft){
                if((scrolledX)==reveals[i].offsetLeft){
                    //alert("change from scroller");
                    vm.setItem(i,false);               
                    //console.log("[SELECTED !] vm.selectedIndex="+vm.selectedIndex);
                }
            }
        },
        setItem(index,fromTimer)
        {
            //if(fromTimer==false){
                //this.stopAutoChange()
            //}
            this.selectedIndex = index;            
            //this.scrollImg();
        },
        scrollImg()
        {
            if(isMobileScreen()){
                //scroll on mobile version
                //let scrollToElement = this.$refs.bnImgScroll1.getElementsByClassName("bnImgItem")[this.selectedIndex];
                //scrollToElement.scrollIntoView({ behavior:'smooth',inline:'center',block:'nearest'});
            }else{
                //fade in/out relevent images on desktop version

            }

        }
    }
};
</script>

